<template>
  <ValidationObserver @submit="contactUsRequest">
    <UiModalContainer
      footer-classes="flex justify-end gap-3"
      :disable-position-center="true"
      :modal-show="modal"
      :modal-width="50"
      @handleClick="handleClick"
    >
      <template v-slot:header>
        <span>Contanct Us</span>
      </template>
      <template v-slot>
        <div class="checkInModal-body">
          <InputFieldWrapper>
            <UiInput
              v-model="contactUs.first_name"
              type="text"
              name="First Name"
              title="First Name"
              label="First Name"
              placeholder="Enter First Name"
              :rules="nameRules"
            />
            <UiInput
              v-model="contactUs.last_name"
              type="text"
              name="Last Name"
              title="Last Name"
              label="Last Name"
              placeholder="Enter Last Name"
              :rules="nameRules"
            />
            <UiInput
              v-model="contactUs.email"
              type="email"
              name="Email"
              title="Email"
              label="Email"
              :rules="emailRules"
              placeholder="Email"
            />
            <PhoneNumber v-model="staffNumber" title="Phone Number" @update="updateStaffNumber" />
          </InputFieldWrapper>
          <InputFieldWrapper>
            <UiInput
              v-model="contactUs.subject"
              type="text"
              name="Subject"
              title="Subject"
              label="Subject"
              class="w-full"
              :rules="required"
              placeholder="Subject"
            />
          </InputFieldWrapper>
          <InputFieldWrapper>
            <UiInput
              v-model.trim="contactUs.message"
              type="textarea"
              name="Message"
              title="MESSAGE"
              class="mt-2"
              :rules="textAreaRules"
              placeholder="Write"
            />
          </InputFieldWrapper>
        </div>
      </template>
      <template v-slot:footer>
        <div class="flex gap-3 rtl:gap-x-4">
          <UIButton button="primary" :disabled="isLoading">
            <span v-if="isLoading">
              <Loader />
            </span>
            <span v-else>Send Message</span>
          </UIButton>
        </div>
      </template>
    </UiModalContainer>
  </ValidationObserver>
</template>

<script>
/* COMPONENTS */
import UiModalContainer from '@components/UiElements/UiModalContainer.vue'
import UiInput from '@components/UiElements/UiInputBox.vue'
import Loader from '@components/BaseComponent/Loader.vue'
import PhoneNumber from '@components/UiElements/PhoneNumber.vue'
import { Form as ValidationObserver } from 'vee-validate'
import GENERAL_CONSTANTS from '@/src/constants/general-constants.js'
/* vuex */
import { mapActions, mapState } from 'vuex'
import UIButton from '@src/components/UiElements/UIButton.vue'
import InputFieldWrapper from '@/src/components/UiElements/InputFieldWrapper.vue'
import RULE_CONSTANTS from '@src/constants/rule.constants.js'

export default {
  components: {
    UiModalContainer,
    UiInput,
    ValidationObserver,
    Loader,
    PhoneNumber,
    UIButton,
    InputFieldWrapper,
  },
  props: {
    modal: { type: Boolean },
  },
  emits: ['toggle'],
  data() {
    return {
      GENERAL_CONSTANTS,
      staffNumber: '',
      dashboard: 'dashboard',
      contactUs: {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
      },
    }
  },

  computed: {
    required() {
      return `${RULE_CONSTANTS.REQUIRED}`
    },
    nameRules() {
      return `${RULE_CONSTANTS.REQUIRED}|${RULE_CONSTANTS.ALPHA_SPACES}`
    },
    emailRules() {
      return `${RULE_CONSTANTS.REQUIRED}|${RULE_CONSTANTS.EMAIL}`
    },
    textAreaRules() {
      return `${RULE_CONSTANTS.REQUIRED}|${RULE_CONSTANTS.TEXTAREA_RANGE}`
    },
    ...mapState('layout', ['campuses', 'isLoading', 'currentCampusScope']),
    ...mapState('instituteCount', ['instituteCount']),
    ...mapState({
      defaultCountry: (state) => state.layout?.generalSettings?.default_country,
    }),
  },

  methods: {
    handleClick(eventName) {
      switch (eventName) {
        case 'close':
          this.$emit('toggle')
          break
      }
    },
    updateStaffNumber(payload) {
      this.contactUs.phone = payload.formattedNumber
    },
    async contactUsRequest() {
      let [response] = await this.sendContactUsRequest(this.contactUs)
      if (response?.data) {
        this.resetForm()
        this.$emit('toggle', true)
      }
    },
    resetForm() {
      this.contactUs = {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
      }
      this.staffNumber = ''
    },
    ...mapActions('paymentMethods', ['sendContactUsRequest']),
  },
}
</script>
